import { render } from "./PR2-061522.vue?vue&type=template&id=f096592e"
import script from "./PR2-061522.vue?vue&type=script&lang=js"
export * from "./PR2-061522.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__